import request from "../../components/request";
import priceList from "./priceList";

$("#calculate-pills").on("click", function () {
  const value = $("#doses_for_pills").val();
  if (value != "Wybierz" && value != "1.25") {
    $("#wrapper-pills").removeClass("d-none");
    $("#loader-pills").removeClass("d-none").addClass("d-flex");
    $("#data-pills").addClass("d-none");
    $("#hidden-txt").addClass("d-none");
    asyncGetDataPills(value);
  } else if (value == "1.25") {
    $("#hidden-txt").removeClass("d-none");
    $("#wrapper-pills").addClass("d-none");
  } else {
    $("#wrapper-pills").addClass("d-none");
    $("#hidden-txt").addClass("d-none");
  }
});

async function asyncGetDataPills(value) {
  const pills = await request("calculator", "pills", { dose: value });
  const listPrice = await priceList();
  setDataPills(pills, listPrice);
}

function setDataPills(pills, listPrice) {
  $("#data-pills").html(resultsDataPills(pills, listPrice));
  $("#loader-pills").removeClass("d-flex").addClass("d-none");
  $("#data-pills").removeClass("d-none").fadeIn(300);
}

function resultsDataPills(pills, listPrice) {
  const src = "/app/themes/chiesi/images";
  let pillsSection = "";
  let pillsAmount = 0;
  let packagesSection = "";
  let priceList = "";

  pills.pills.forEach((pills) => {
    if (pills.amount > 0) {
      let pillsDose = pills.dose;
      pillsDose =
        pillsDose < 1 ? String(pillsDose).replace(".", "_") : pillsDose;
      pillsAmount += parseInt(pills.amount);
      pillsSection += `
        <tr>
          <td class="doses__desc">
            <img src="${src}/pill_${pillsDose}.png" alt="">
            <span>Tabletki ${pills.dose} mg</span>
          </td>
          <td class="doses__val">${pills.amount} tabl./dobę</td>
        </tr>`;
    }
  });

  let totalPrice = pills.packages.totalPrice;
  totalPrice = String(totalPrice.toFixed(2)).replace(".", ",");
  pills.packages.packages.forEach((pack) => {
    if (pack.amount > 0) {
      let packDose = pack.package.dose;
      packDose = packDose < 1 ? String(packDose).replace(".", "_") : packDose;
      let packPrice = pack.package.price;
      packPrice = String(packPrice.toFixed(2)).replace(".", ",");
      packagesSection += `
        <tr>
          <td class="doses__desc">
            <img src="${src}/envarsus-${packDose}-${pack.package.amount}tab.png" alt=""> 
            <span>
              ENVARSUS® ${pack.package.dose} mg <br>
              ${pack.package.amount} tabl.
            </span>
          </td>
          <td class="doses__val">${pack.amount} op./m-c</td>
        </tr>`;
    }
  });

  listPrice.products.forEach((item) => {
    priceList += `
      <tr>
        <td class="doses__desc">
          ${item.title} <br>
          ${item.package} 
        </td>
        <td class="doses__val">${item.price}</td>
      </tr>`;
  });

  return `
    <p class="large gray">Optymalny<sup class="blue">*</sup> rozkład tabletek dla wybranego dobowego dawkowania:</p>
    <table class="doses">
      ${pillsSection}
      <tr>
        <td class="doses__val blue">Łączna liczba tabletek:</td>
        <td class="doses__val blue">${pillsAmount} tabl./dobę</td>
      </tr>
    </table>
    <hr class="mb-10">
    <p class="large gray">Ilość opakowań potrzebnych na 30-dniową terapię<sup class="blue">**</sup>:</p>
    <table class="doses">
      ${packagesSection}
      <tr>
        <td class="doses__val blue">Koszt zakupu leku, który poniesie pacjent<sup class="blue">**</sup>:</td>
        <td class="doses__val blue">${totalPrice} zł</td>
      </tr>
    </table>
    <hr class="mb-10">
    <p class="large gray">Aktualne ceny dla pacjenta<sup class="blue">2</sup></p>
    <table class="doses">
      ${priceList}
    </table>`;
}
